import { generateMeasuresFromDimensions } from './generate-measures.js';
import { meetingLink } from './links.js';
import { meetingStatusValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'media_archives.duration_minutes': {
        aggregations: ['avg', 'max', 'sum'],
        label: 'Duration (Minutes)',
        type: 'number',
    },
};
/** Video recordings and media archives associated with meetings. */
export const mediaArchivesCube = {
    category: 'Meetings',
    description: 'Video recordings and media archives for meetings with playback and duration data.',
    label: 'Meeting Recordings',
    requiredModule: 'hasRecord',
    measures: {
        'media_archives.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
    },
    dimensions: {
        ...aggregatableDimensions,
        'media_archives.has_playback': { label: 'Has Playback', type: 'boolean' },
        'media_archives.has_thumbnail': { label: 'Has Thumbnail', type: 'boolean' },
        'meetings.status': {
            label: 'Meeting Status',
            type: 'string',
            valueLabels: meetingStatusValueLabels,
        },
        'meetings.title': { label: 'Meeting Title', link: meetingLink, type: 'string' },
    },
    timeDimensions: {
        'media_archives.created_at': { label: 'Created At', type: 'date' },
        'meetings.date': { label: 'Meeting Date', type: 'date' },
    },
};
